import http from "../http-common";

class PaymentService {
    getProducts() {
        return http.get("kids/website/products");
    }
    getProductDetail(data) {
        return http.get("kids/website/product", { params: data });
    }
    addProductToCart(data) {
        return http.post("kids/website/cart/add", data);
    }
    getCartCount() {
        return http.get("kids/website/cart/count");
    }
    getCartItems() {
        return http.get("kids/website/cart/items");
    }
    updateCartQty(data) {
        return http.post("kids/website/cart/update", data);
    }
    deleteCartItem(data) {
        return http.post("kids/website/cart/delete", data);
    }
    stripeCheckout(data) {
        return http.post("kids/website/stripe/checkout", data);
    }
    getCheckoutSessionDetail(data) {
        return http.get("kids/website/stripe/session/detail", { params: data });
    }
}

export default new PaymentService();